export const CONFIG_THUMBNAIL_MAX_INPUT_SIZE = 209715200;
export const CONFIG_THUMBNAIL_MAX_JOB_SIZE = 524288000;
